export default "__VITE_ASSET__c8c69591__"